export const initialState = {
    is_loading: true,
    is_loading_btn: false,
    messages_list: [],
    images: []
}